import moment from 'moment-timezone';
import {useUserStore} from 'entities/user';

export const getStartAt = () => {
  const now = new Date();

  let minutes = now.getMinutes();

  while (minutes % 15 !== 0) {
    minutes++;
  }

  return new Date(now.setMinutes(Number(minutes), 0, 0));
};

export const getEndAt = () => {
  const startAt = getStartAt();

  return new Date(startAt.getTime() + 900000);
};

export function pickerDateToUtcIso(date: Date) {
  const userTz = useUserStore.getState().userInfo?.timezone;
  const tz = userTz ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');

  return moment.tz(`${y}-${m}-${d} ${h}:${min}`, 'YYYY-MM-DD HH:mm', tz).utc().toISOString();
}

export function utcToUserDate(utc: string | Date, msg?: string): Date {
  const userTz =
    useUserStore.getState().userInfo?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

  const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const mUtc = moment.utc(utc);

  const userOffset = moment.tz(mUtc, userTz).utcOffset();
  const systemOffset = moment.tz(mUtc, systemTz).utcOffset();

  const diffMinutes = userOffset - systemOffset;

  return mUtc.add(diffMinutes, 'minutes').toDate();
}

export function getNowForUserTz(): Date {
  const userTz =
    useUserStore.getState().userInfo?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

  const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const mUtcNow = moment.utc();

  const userOffset = moment.tz(mUtcNow, userTz).utcOffset();
  const systemOffset = moment.tz(mUtcNow, systemTz).utcOffset();

  const diffMinutes = userOffset - systemOffset;

  return mUtcNow.add(diffMinutes, 'minutes').toDate();
}

export function getLastHappinessUpdate(): Date {
  const now = Date.now(); // Текущее время в мс
  const interval = 15 * 60 * 1000; // 15 минут в мс
  // Вычитаем остаток от деления, чтобы "округлить вниз" до кратных 15 минут
  const lastUpdateTimestamp = now - (now % interval);
  return new Date(lastUpdateTimestamp);
}